/**
 * Scroll Animations
 * =================
 * Triggers slide-up and fade-in animations for Elementor widgets
 * when they come into the viewport using Intersection Observer.
 * Only active on front-end, not in Elementor editor.
 */

(function () {
	'use strict';

	// Exit early if in Elementor editor
	if (document.body.classList.contains('elementor-editor-active')) {
		return;
	}

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	function init() {
		// Get all Elementor widgets
		const widgets = document.querySelectorAll('.elementor-widget');

		if (widgets.length === 0) {
			return;
		}

		// Configure Intersection Observer options
		const observerOptions = {
			root: null, // viewport
			rootMargin: '0px 0px -50px 0px', // Trigger when 50px from bottom of widget is visible
			threshold: 0 // Trigger as soon as any part is visible
		};

		// Create intersection observer
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					// Add visible class to trigger animation
					entry.target.classList.add('is-visible');
					// Unobserve after animation is triggered (performance optimization)
					observer.unobserve(entry.target);
				}
			});
		}, observerOptions);

		// Observe all widgets
		widgets.forEach((widget) => {
			observer.observe(widget);
		});
	}
})();

